import React from "react";
import PropTypes from "prop-types";
import Head from "next/head";

import AppBar from "./AppBar";
import Footer from "./Footer";
import ChampProgressBar from "./ChampProgressBar";

const Layout = ({
  children,
  pageTitle,
  pageDescription,
  bgColor,
  footer,
  header,
  progressBar,
}) => (
  <>
    <Head>
      <meta
        name="description"
        content={
          pageDescription ||
          "Get Your Kids Moving & Practicing Mindfulness with GoNoodle®. Start Watching Now & Get Access to Hundreds of Videos! Active Learning. Healthy Kids. Active Kids. Boost Learning."
        }
      />

      <title>{`GoNoodle ${pageTitle || ""}`}</title>
    </Head>
    <div className="gn-page">
      {header ? <AppBar /> : null}
      <main role="main" className={`${bgColor} flex flex-col gn-main`}>
        <h1 className="sr-only">{pageTitle} Page</h1>
        {progressBar ? <ChampProgressBar /> : null}
        {children}
      </main>
      {footer ? <Footer /> : null}
    </div>
  </>
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  pageTitle: PropTypes.string,
  pageDescription: PropTypes.string.isRequired,
  bgColor: PropTypes.string,
  footer: PropTypes.bool,
  header: PropTypes.bool,
  progressBar: PropTypes.bool,
};

Layout.defaultProps = {
  bgColor: "bg-gray-900",
  pageTitle: undefined,
  footer: true,
  header: true,
  progressBar: false,
};

export default Layout;
